import { JsonProperty } from '../utils/json-typescript-mapper';
import { BaseModel } from './base.model';

export class AnonymousCompanyCustomMessage extends BaseModel<AnonymousCompanyCustomMessage> {

    @JsonProperty('CompanyCode')
    companyCode: string;

    @JsonProperty ('MessageCodes')
    messageCodes: string[];

    constructor(properties?: Partial<AnonymousCompanyCustomMessage>) {
        super({
            companyCode: undefined,
            messageCodes: undefined
        }, properties);
    }
}
